import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Applocation',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "14", height: "22", viewBox: "0 0 14 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M4 18H10V19H4V18Z", fill: "currentColor" }
      }), h("path", {
        attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.66666 9.99996C4.66666 8.70996 5.71 7.66663 7 7.66663C8.29 7.66663 9.33333 8.70996 9.33333 9.99996C9.33333 11.75 7 14.3333 7 14.3333C7 14.3333 4.66666 11.75 4.66666 9.99996ZM6.16666 9.99996C6.16666 10.46 6.54 10.8333 7 10.8333C7.46 10.8333 7.83333 10.46 7.83333 9.99996C7.83333 9.53996 7.46 9.16663 7 9.16663C6.54 9.16663 6.16666 9.53996 6.16666 9.99996Z", fill: "currentColor" }
      }), h("path", {
        attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 0C1.34315 0 0 1.34315 0 3V19C0 20.6569 1.34315 22 3 22H11C12.6569 22 14 20.6569 14 19V3C14 1.34315 12.6569 0 11 0H3ZM4 2H3C2.44771 2 2 2.44772 2 3V19C2 19.5523 2.44772 20 3 20H11C11.5523 20 12 19.5523 12 19V3C12 2.44772 11.5523 2 11 2H10V3H4V2Z", fill: "currentColor" }
      })]
    );
  }
};